import SideMenu from './SideMenu'
import NoteDisplay from './NoteDisplay'
import React, { useRef, useState, Component } from 'react'
import { saveNote, deleteAllNotes, deleteNote, getNotes } from '../notesService'
import AboutApp from './AboutApp'
import Note from '../Note'

class App extends React.Component {

  constructor(props){
    super(props)
    this.state = {notes: getNotes()}
  }

  addNote(){
    let note = new Note();
    note.setId();
    this.setState({selectedNote: note})
  }

  showInfo(){
    this.setState({selectedNote: null})
  }

  deleteNote(noteId) {
    deleteNote(noteId)
    let notes = getNotes()
    this.setState({notes: notes, selectedNote: null})
  }

  saveCurrentNote(note) {
    saveNote(note)
    let notes = getNotes()
    this.setState({notes: notes, selectedNote: notes.filter(x=>x.id == note.id)[0]})
  }

  changeSelectedNote(note){
    this.setState({notes: this.state.notes, selectedNote: note})
  }

  render() {
    return (
      <div className='w3-row'>
        <div className='w3-panel w3-teal w3-card'>
          <h1>Offline Notes Keeper <span style={{fontSize: '10px', fontWeight:'bold'}}>| v1.01</span></h1>
        </div>

        <div className='w3-col m3 l3'>
          
          <div className="w3-bar w3-light-grey w3-border navigation-menu">
            <a href="#" className="w3-bar-item w3-button w3-green" onClick={this.addNote.bind(this)}><i className="fa fa-plus"></i></a>
            <a href="#" className="w3-bar-item w3-button w3-blue" onClick={this.showInfo.bind(this)}><i className="fa fa-info"></i></a>          
          </div>

          <SideMenu 
              selectedNote={this.state.selectedNote}
              notes={this.state.notes}
              changeSelectedNote = {this.changeSelectedNote.bind(this)}/>
        </div>

        <div className='w3-col m8 l9'>
          { this.state.selectedNote != null ?
          <NoteDisplay
            note={this.state.selectedNote}
            deleteNote={this.deleteNote.bind(this)}
            saveCurrentNote={this.saveCurrentNote.bind(this)}
          />: <AboutApp/>
          }
        </div>
      </div>
    )
  }
}

export default App
